/**
 * Api error representation
 */
export class ApiError extends Error {
  status:       number
  message:      string
  name:         string

  constructor(error: IApiError) {
    super(error.message)
    this.status   = error.status
    this.message  = error.message
    this.name     = 'HTTP request error'
  }
}

export interface IApiError extends Omit<Error, 'name'> {
  /**
   * HTTP response status,
   * 0 on network fails
   */
  status: number;
}

export default ApiError
